var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scope.activeTabIndex === 0)?_c('wizard-button',{staticClass:"btn btn-gray",attrs:{"id":"skip"},nativeOn:{"click":function($event){return _vm.$emit('skip', $event)}}},[_vm._v("\n  Skip This\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }